import { RootState } from '../index';

export const getProductsPurchasedSortFilters = (state: RootState) => ({
  sort: state.productsPurchased.sortBy,
  filter: state.productsPurchased.filterBy,
  keyword: state.productsPurchased.keyword,
  currentPage: state.productsPurchased.currentPage,
});
